import axios from "axios";
import { TTP_API_URL } from "Config";

export const getTags = ({ token, lng = "fr", filter = null }) => {
  //TODO add language in fields
  const requestUrl = `${TTP_API_URL}/blog/tag`;

  return axios.get(requestUrl, {
    // cancelToken: getTagsSourceToken.token,
    params: {
      access_token: token,
      fields: "id, nameFr, nameEn, nameNl, sanitizedNameFr, parent, isSynonym",
      filter: JSON.stringify(filter)
    }
  });
  // .catch(function(thrown) {
  //   // throwCatchedError(thrown);
  // });
};

export const getUsers = ({ token, search, community }) => {
  const requestUrl = `${TTP_API_URL}/organization/user`;

  const filter = [
    // Filter by organization is handled by api permission filter
    // {
    //   property: "organization.id",
    //   operator: "eq",
    //   value: community.id
    // }
  ];

  if (search) {
    filter.push({
      property: "name",
      operator: "like",
      value: search
    });
  }

  const sort = [
    {
      property: "firstName",
      dir: "asc"
    }
  ];

  return axios.get(requestUrl, {
    params: {
      access_token: token,
      fields: "*, avatar",
      filter: JSON.stringify(filter),
      sort: JSON.stringify(sort)
    }
  });
};



// WEBPACK FOOTER //
// ./src/api/filter.js